import styled from 'styled-components'

import { mainColors } from '../../../styles/colors'
import { _S_Medium } from '../../../styles/typography'

export const GroupLabel = styled.div`
  position: relative;
  ${_S_Medium};
  padding: 12px 18px;

  &:not(:first-of-type) {
    margin-top: 30px;

    &::before {
      content: '';
      position: absolute;
      top: -15px;
      height: 1px;
      width: calc(100% - 36px);
      background-color: ${mainColors.neutralMedium};
    }
  }
`
